import { Checkbox } from "primereact/checkbox";

export default function WorkOrderCheckbox(props) {
  const { title, isChecked, onChecked } = props;
  return (
    <div className="flex justify-between">
      <p className="text-md font-bold">{title}</p>{" "}
      <Checkbox checked={isChecked} onChange={(e) => onChecked(e)}></Checkbox>
    </div>
  );
}
